var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6577 1.44338C27.2047 0.550212 29.1107 0.550212 30.6577 1.44338L49.4734 12.3066C51.0204 13.1998 51.9734 14.8504 51.9734 16.6368V38.3632C51.9734 40.1496 51.0204 41.8002 49.4734 42.6934L30.6577 53.5566C29.1107 54.4498 27.2047 54.4498 25.6577 53.5566L6.84202 42.6934C5.29501 41.8002 4.34202 40.1496 4.34202 38.3632V16.6368C4.34202 14.8504 5.29501 13.1998 6.84202 12.3066L25.6577 1.44338Z",
    fill: "#2C8BFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3247 34.4445H23.9914M17.3247 18.8889H21.7692H17.3247ZM37.3247 18.8889H26.2136H37.3247ZM17.3247 26.6667H30.658H17.3247ZM37.3247 26.6667H35.1025H37.3247ZM17.3247 34.4445H19.5469H17.3247Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9918 21.1111C25.2191 21.1111 26.214 20.1162 26.214 18.8889C26.214 17.6616 25.2191 16.6667 23.9918 16.6667C22.7645 16.6667 21.7695 17.6616 21.7695 18.8889C21.7695 20.1162 22.7645 21.1111 23.9918 21.1111Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8804 28.889C34.1077 28.889 35.1026 27.894 35.1026 26.6667C35.1026 25.4394 34.1077 24.4445 32.8804 24.4445C31.6531 24.4445 30.6582 25.4394 30.6582 26.6667C30.6582 27.894 31.6531 28.889 32.8804 28.889Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7696 36.6667C22.9969 36.6667 23.9918 35.6718 23.9918 34.4445C23.9918 33.2172 22.9969 32.2222 21.7696 32.2222C20.5423 32.2222 19.5474 33.2172 19.5474 34.4445C19.5474 35.6718 20.5423 36.6667 21.7696 36.6667Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.d54811cf7d2398d2906262759b8af8ca.svg";
export { ForwardRef as ReactComponent };